<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <data-table ></data-table>
        </div>
        <!-- end of card body -->
      </div>
      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
</template>
<script>
import DataTableVue from "./components/DataTable.vue";
export default {
  name: "Furqan1StudentsFilter",
  components: {
    "data-table": DataTableVue,
  },
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped></style>
